module.exports = __webpack_public_path__ + "static/media/sidebar-sms-selected.792aeac5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-sms-selected.svg
// module id = 790
// module chunks = 0